{
  "secretary": {
    "navLabel": "Smart secretary",
    "title": "{{brand}} smart secretary",
    "recorder": {
      "record": "Say one command — e.g. “book Rezaei tomorrow at ten”",
      "recording": "Listening…",
      "stop": "Stop and run",
      "discard": "Discard",
      "processing": "The secretary is working…",
      "warn": {
        "nothing": "I heard nothing",
        "busy": "The secretary is still on the last command",
        "mic": {
          "denied": "Microphone permission was not given",
          "unsupported": "This browser cannot record sound",
          "error": "The microphone did not open"
        }
      }
    },
    "notice": {
      "listLabel": "Smart secretary results",
      "heard": "Heard: “{{text}}”",
      "dismiss": "Dismiss",
      "more": "{{count}} more",
      "open": "Open",
      "bookReady": "Appointment for {{name}} is ready",
      "followUpReady": "Follow-up for {{name}} is ready",
      "slotLine": "{{day}}, {{time}}",
      "slotLineClinic": "{{day}}, {{time}} — {{clinic}}",
      "noSlot": "No free time found",
      "choosePatient": "Which “{{name}}”?",
      "candidates": "{{count}} patients with this name",
      "notFound": "“{{name}}” is not among your patients",
      "openRecord": "{{name}}’s record",
      "daySummary": "You have {{total}} appointments today",
      "noClinic": "You have no clinic to book at",
      "outOfScope": "The secretary does not do this",
      "unavailable": "Today’s schedule could not be read",
      "unknown": "I did not understand",
      "failed": "The secretary could not do it",
      "noCredit": "Not enough {{coin}}"
    },
    "window": {
      "close": "Close",
      "recordAgain": "Say it again",
      "heard": "Heard",
      "openForm": "Open the booking form",
      "pickSlot": "Pick one of these times; the booking form opens filled in with it.",
      "hourTaken": "{{time}} is taken; the nearest free times:",
      "hourFree": "{{time}} is free.",
      "slot": "{{day}}, {{time}}",
      "requestOnly": "This clinic has closed direct booking; the appointment is sent as a request for reception to confirm.",
      "noSlotLine": "No free time was found for {{name}} in this window. You can open the form and choose another day.",
      "choosePatientLine": "You have several patients with a name close to “{{name}}”. Which one?",
      "newPatient": "New patient",
      "file": "File {{file}}",
      "age": "{{age}} y",
      "phoneTail": "Mobile …{{tail}}",
      "notFoundLine": "No patient named “{{name}}” was found among your clinics’ patients.",
      "closest": "Closest names:",
      "noClinicTitle": "You have no clinic yet",
      "noClinicLine": "To book appointments you must be a member of a clinic or create your own practice. The secretary can still open records and tell you today’s schedule.",
      "readOnlyTitle": "Your clinics’ subscriptions have ended",
      "readOnlyLine": "Nothing can be booked at a clinic until it renews its subscription.",
      "goReception": "Go to reception",
      "dayTitle": "You have {{total}} appointments today",
      "dayCounts": "{{completed}} done · {{arrived}} present · {{scheduled}} waiting",
      "dayRequested": "{{count}} requests awaiting the clinic’s confirmation",
      "dayNext": "Ahead:",
      "dayNone": "Nothing else is ahead today.",
      "noHour": "Walk-in",
      "unknownPatient": "Patient",
      "status": {
        "scheduled": "Waiting",
        "requested": "Awaiting the clinic",
        "arrived": "Present",
        "in_visit": "In visit"
      },
      "outOfScopeTitle": "The secretary does not do this",
      "topic": {
        "clinical_record": "Write prescriptions, diagnoses and notes in the visit itself.",
        "visit_flow": "Visits are started and ended from reception and the visit itself.",
        "mark_arrived": "Marking a patient present is the clinic reception’s job.",
        "reschedule_or_cancel": "To move or cancel an appointment, open it in reception.",
        "money": "See money matters in Accounting.",
        "send_message": "Send messages to patients from Messages.",
        "delete_record": "The secretary never deletes anything.",
        "other": "The secretary prepares appointments and follow-ups, opens records and tells you today’s schedule."
      },
      "unavailableLine": "Today’s schedule could not be read right now. Ask again in a moment.",
      "unknownLine": "The secretary can prepare appointments and follow-ups, open a record and tell you today’s schedule.",
      "failedLine": "Say it again. If it keeps failing, do it from its own page.",
      "noCreditLine": "Top up your {{coin}} to use the secretary.",
      "topUp": "Top up {{coin}}",
      "charged": "{{coin}} was deducted for this command.",
      "notCharged": "No {{coin}} was deducted for this command."
    },
    "form": {
      "notice": "The smart secretary filled in this form from what you said; check it before booking.",
      "reception_clinic": "Clinic: the one selected in reception.",
      "working_hours": "The clinic was chosen from your working hours.",
      "earliest_free": "The clinic with the earliest free time was chosen.",
      "newPatient": "New patient: their record is created when the appointment is booked.",
      "heardPhone": "Number I heard: {{phone}}",
      "booked": "Appointment booked.",
      "requested": "Appointment request sent to the clinic for confirmation."
    }
  }
}
